<template>
  <div class="custom">
    <h2>FA融资</h2>
    <h5>一匠为企业提供不同维度、不同阶段的股权融资资源，<br/>
精准对接，提供针对PE\VC基金、产业资本基金、并购重组等的专业FA服务。</h5>
    <div class="text">一匠推出FA融资服务，立足于产业，提供产业链价值资源，全方位帮助创业公司实现高速成长的重要一步，一匠将会在资源服务的基础上，帮助客户找到靠谱的投资人，为客户提供全方位，高效，专业的一站式融资服务。</div>
    <!-- <div class="custom-list">
      <div
        class="item"
        v-for="item in customList"
        :key="item.id"
        @mouseenter="mouseEnter(item.id)"
        @mouseleave="mouseLeave"
        @click="pageUrl(item.url)"
      >
        <img v-if="enterIndex == item.id" :src="item.acitveImg" />
        <img v-else :src="item.img" />
        <div class="desc" :class="{ active: enterIndex == item.id }">
          {{ item.desc }}
        </div>
      </div>
    </div> -->
    <div class="custom_bg"></div>
    <div class="tab_list">
            <div class="tab-item" v-for="(item,index) in customList" :key="index">
              <div class="tab-img">
                <img :src="item.img" alt="" srcset="">
                <div class="index">{{item.id}}</div>
                <div class="item_title">{{item.desc}}</div>
              </div>
              <div class="arrows_box" v-if="!item.showArrows">
                <img src="../../static/images/custom/jiantou1.png" class="arrows" alt="" srcset="">
                <img src="../../static/images/custom/jiantou1.png" class="arrows" alt="" srcset="">
                <img src="../../static/images/custom/jiantou1.png" class="arrows" alt="" srcset="">
              </div>
            </div>
    </div>

    <h2 style="margin-top:100px">为什么选择我们？</h2>
    <h5>技术助力、产品赋能、商业成功</h5>
    <div class="serviceSystem">
      <div class="service_left">
          <p>“1+10”核心产品服务体系</p>
          <img src="../../static/images/custom/service.png" alt="" class="service_bg" srcset="">
      </div>
      <div class="service_right">
            <div class="service_right_item">
                <img src="../../static/images/custom/jishuzhuli.png" alt="" srcset="">
                <div class="service_font">
                  <p>技术助力</p>
                  <span>建立先进的研发管理流程及严格的质量控制体系，实现 技术助力</span>
                </div>
            </div>
            <div class="service_right_item">
                <img src="../../static/images/7mouth/chanpinfuneng.png" alt="" srcset="">
                <div class="service_font">
                  <p>产品赋能</p>
                  <span>提供“1+10”核心产品服务体系，实现产品赋能</span>
                </div>
            </div>
            <div class="service_right_item">
                <img src="../../static/images/7mouth/shangyechenggong.png" alt="" srcset="">
                <div class="service_font">
                  <p>商业成功</p>
                  <span>洞察商业模式的核心价值与风险，实现商业成功</span>
                </div>
            </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      enterIndex: -1,

      customList:[{
          id:'01',
          img:require("../../static/images/custom/dingzhirongzi.png"),
          desc:'定制融资策略'
      },{
          id:'02',
          img:require("../../static/images/custom/shulishangye.png"),
          desc:'梳理商业结构'
      },{
          id:'03',
          img:require("../../static/images/custom/duijieyiliu.png"),
          desc:'对接一流投资机构'
      },{
          id:'04',
          img:require("../../static/images/custom/tigongchanye.png"),
          desc:'提供产业资源'
      },{
          id:'05',
          img:require("../../static/images/custom/wajuechanye.png"),
          desc:'深挖产业服务',
          showArrows:true
      }]
      // customList: [
      //   {
      //     id: 0,
      //     img: require("../../static/images/custom/wulianwanghei.png"),
      //     acitveImg: require("../../static/images/custom/wulianwanghuang.png"),
      //     url: "/custom",
      //     desc: "物联网&智能软硬定制",
      //   },
      //   {
      //     id: 1,
      //     img: require("../../static/images/custom/apphei.png"),
      //     acitveImg: require("../../static/images/custom/app.png"),
      //     url: "/custom",
      //     desc: "APP定制",
      //   },
      //   {
      //     id: 2,
      //     img: require("../../static/images/custom/qiyehei.png"),
      //     acitveImg: require("../../static/images/custom/qiyehuang.png"),
      //     url: "/custom",
      //     desc: "企业系统定制",
      //   },
      //   {
      //     id: 3,
      //     img: require("../../static/images/custom/gongzhonghaohei.png"),
      //     acitveImg: require("../../static/images/custom/gongzhonghao.png"),
      //     url: "/custom",
      //     desc: "微信公众号定制",
      //   },
      //   {
      //     id: 4,
      //     img: require("../../static/images/custom/xiaocchengxuhei.png"),
      //     acitveImg: require("../../static/images/custom/xiaocchengxuhuang.png"),
      //     url: "/custom",
      //     desc: "微信小程序定制",
      //   },
      //   {
      //     id: 5,
      //     img: require("../../static/images/custom/webhei.png"),
      //     acitveImg: require("../../static/images/custom/webhuang.png"),
      //     url: "/custom",
      //     desc: "Web系统定制",
      //   },
      // ],
    };
  },
  methods: {
    mouseEnter(index) {
      this.enterIndex = index;
    },
    mouseLeave() {
      this.enterIndex = -1;
    },
    pageUrl(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style lang="stylus" scoped>
.custom {
  box-sizing: border-box;
  width: 100%;
  // height: 450px;
  background-color: #fff;
  padding: 80px 0;
  position: relative;

  .custom_bg {
    position: absolute;
    top: 315px;
    width: 100%;
    height: 460px;
    background: url('../../static/images/custom/custom_bg.png') no-repeat;
    background-size:100% 85%;
    background-position: center;
  }

  .text {
    width: 938px;
    height: 163px;
    padding: 38px 41px;
    margin: 60px auto 21px;
    text-align: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 32px;
    background: rgba(255, 192, 0, 0.1);
    box-shadow: 0px 3px 30px 0px rgba(69, 79, 107, 0.08);
    position: relative;
    z-index: 2;
  }

  h2 {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

  h5 {
    text-align: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }

  .tab_list {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.9;

    .tab-item {
      display: flex;
      align-items: center;

      .tab-img {
        display: flex;
        flex-direction: column;
        align-items: center;

        .index {
          font-size: 28px;
          font-family: DIN;
          font-weight: bold;
          color: #333333;
        }

        .item_title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #666666;
        }
      }

      .arrows_box {
        width: 110px;
        justify-content: space-around;
        display: flex;
        align-items: center;

        .arrows {
          width: 6px;
          height: 8px;
          margin-bottom:30px
        }
      }
    }
  }

  .serviceSystem {
    height: 427px;
    margin-top: 47px;
    display: flex;
    justify-content: center;
    align-items: center;

    .service_left {
      width: 790px;
      height: 427px;
      background: #FFFFFF;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
      display:flex;
      flex-direction column;
      align-items:center;
      justify-content:center;
      p{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .service_bg {
        margin-top:31px;
        width: 582px;
        height: 307px;
      }
    }
    .service_right{
      display: flex;
      flex-direction column;
      justify-content: space-between;
      height: 427px;
      // align-items: center;
      margin-left:24px
      .service_right_item{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 586px;
        height: 135px;
        background: #FFFFFF;
        box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
        border-radius: 4px;
        transition: transform 0.4s;
        img{
          height:40px;
          width:40px;
          margin-right:11px;
          margin-bottom:40px;
        }
        .service_font{
          p{
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }
          span{
            margin-top:23px;
            display:inline-block;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            width 414px;

          }
        }
      }
      .service_right_item:hover{
        transform: scale(1.03);
      }
    }
  }

  .custom-list {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-items: center;

    .item {
      width: 200px;
      text-align: center;
    }

    .active {
      color: #FFC000;
    }

    .desc {
      padding-top: 30px;
      font-size: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/HomeCustom.vue